<script>
    import Card from '@smui/card';
    import {Circle} from 'svelte-loading-spinners'
    import ContactFooter from "../contact/ContactFooter.svelte";
</script>
<div class="container-fluid">
    <div class="row justify-content-center">
        <div class="col-12">
            <Card>
                <div class="cng-card__primary cng-card__header-with-buttons">
                    <div class="mdc-typography--headline5">
                        <slot/>
                    </div>
                    <div>
                        <Circle color="#6200EE"/></div>
                </div>
                <ContactFooter/>
            </Card>
        </div>
    </div>
</div>